import { Star } from "lucide-react";

import { Slider } from "@/components/Slider";
import { cn } from "@/lib/utils";
import {
  ChoiceUIElement,
  HumanConfiguration,
  RatingUIElement,
  SliderUIElement,
} from "@/types/evaluate";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const HumanInputUIComponent = ({
  uiComponent,
  dataType,
  config,
  value,
  setValue,
}: {
  uiComponent: string;
  dataType: string;
  config: HumanConfiguration;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: (value: any) => void;
}) => {
  if (uiComponent === "text") {
    if (dataType === "number") {
      return (
        <Input
          className="col-span-2 w-full rounded border border-gray-300 px-2 py-1 font-mono"
          value={value}
          type="number"
          onChange={e => setValue(Number(e.target.value))}
        />
      );
    }
    return (
      <Textarea
        className="col-span-2 w-full rounded border border-gray-300 px-2 py-1 text-sm"
        value={value}
        rows={4}
        onChange={e => setValue(e.target.value)}
      />
    );
  } else if (uiComponent === "slider") {
    const sliderConfig = config.ui_element as SliderUIElement;
    const min = sliderConfig.min || 0;
    const max = sliderConfig.max || 100;

    return (
      <Slider
        onValueChange={val => setValue(Math.round(Number(val)))}
        value={value?.toString() || "0"}
        isDisabled={false}
        min={min}
        max={max}
        step={0.99}
        hasInput
      />
    );
  } else if (uiComponent === "rating") {
    const ratingConfig = config.ui_element as RatingUIElement;
    const max = ratingConfig.max || 5;
    const numericValue = Number(value) || 0;

    return (
      <div className="flex items-center gap-1">
        {Array.from({ length: max }, (_, index) => {
          const optionValue = index + 1;
          return (
            <button
              key={optionValue}
              type="button"
              className="flex h-6 w-6 items-center justify-center rounded"
              onClick={() => setValue(optionValue)}
            >
              <Star
                className={cn(
                  "h-4 w-4 transition-colors",
                  optionValue <= numericValue
                    ? "fill-amber-400 text-amber-400"
                    : "fill-transparent text-slate-300",
                )}
              />
            </button>
          );
        })}
      </div>
    );
  } else if (uiComponent === "choice") {
    const choiceConfig = config.ui_element as ChoiceUIElement;
    const options = choiceConfig.options.length > 0 ? choiceConfig.options : ["Pass", "Fail"];

    return (
      <div className="flex flex-wrap gap-1.5">
        {options.map(option => (
          <button
            key={option}
            type="button"
            className={cn(
              "rounded-md px-2.5 py-1.5 text-xs font-medium",
              value === option
                ? "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200"
                : "bg-slate-100 text-muted-foreground",
            )}
            onClick={() => setValue(option)}
          >
            {option}
          </button>
        ))}
      </div>
    );
  }
  return <div>Unknown UI component</div>;
};
